export default "__VITE_ASSET__BhBX5pdv__"